module.exports = __webpack_public_path__ + "static/media/STRIVE_logo 2.afddf0c4.svg";